import { DefectsActions } from "../action-types/defectsActionTypes";

const initialState = {
  defectstData: [],
  defectstDetailsData: [],
  defectstPaginationData: [],
  isUpdateSuccessDefectstDetails: false,
};

const defectsReducer = (state = initialState, action) => {
  switch (action.type) {
    case DefectsActions.SET_DEFECTS_LIST:
      return {
        ...state,
        defectstData: action.payload,
      };
    case DefectsActions.SET_DEFECTS_PAGINATION_LIST:
      return {
        ...state,
        defectstPaginationData: action.payload,
      };
    case DefectsActions.SET_DEFECTS_DETAILS_LIST:
      return {
        ...state,
        defectstDetailsData: action.payload,
      };
    case DefectsActions.IS_UPDATE_SUCCESS_DEFECTS_DETAILS:
      return {
        ...state,
        isUpdateSuccessDefectstDetails: action.payload,
      };
    default:
      return state;
  }
};

export default defectsReducer;
